import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { DELIVERIES_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const confirmDeliveryDocumentAction = createAsyncThunk(
    'inventory/confirmDeliveryDocumentAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { id, warehouseType, podId, popId, hubId } = data;
            let url = `${ DELIVERIES_PATH }/${ id }?warehouseType=${ warehouseType }`;


            if (warehouseType === 'POD') {
                url += `&podId=${ podId }`;
            } else {
                url += `&popId=${ popId }&hubId=${ hubId }`;
            }

            const response = await webClient.post(url);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const confirmDeliveryDocumentSlice = createSlice({
    name: 'confirmDeliveryDocumentSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(confirmDeliveryDocumentAction.pending, () => STATE__API__STARTED);
        builder.addCase(confirmDeliveryDocumentAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(confirmDeliveryDocumentAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const confirmDeliveryDocumentState = (state) => state.inventory.confirmDeliveryDocument;
export default confirmDeliveryDocumentSlice.reducer;
